<template>
  <MenuComponent
    :custom_title="$t('Menu.GroupOfAccreditations')">
    <template #navbar>
      <NavBar
        :active="activeMenuIndex"
        :create_router_to="{ name: 'groupOfAccreditationNew', params: { org: $route.params.org } }"
        :create_text="$t('Common.Add')"
        :items="filterOn ? filterMode : fields"
        :loading="loading"
        :types="menuTypes"
        unload
        @filterItems="choseType"/>
    </template>
    
    <template #filter>
      <SearchInput
        debounce
        :search.sync="search"
        width="150px"/>
    </template>
    <template #items>
      <EmptyBlock
        v-if="!loading && sliced_fields.length === 0"
        :text="$t('Common.NoData')"/>
      <div
        v-else
        class="pt-4 width-100 mx-auto"
        style="max-width: 1024px;">
        <GroupOfAccreditationCard
          v-for="(item, n) in sliced_fields"
          :key="(item ? item.id : '') + '' + n"
          :class="{'mb-5': n !== (sliced_fields.length - 1)}"
          :data-qa="'group-of-accreditation-card-' + (item ? item.id : '')"
          :item="item ? item : {}"
          @deactivate="itemId => setNewStatus(itemId, 'ARCHIVE')"
          @publish="itemId => setNewStatus(itemId, 'PUBLISHED')"/>
      </div>
    </template>
    <template #loader>
      <InfinityUpdater
        ref="infinity_updater"
        :action="infinityLoad"
        :active="can_load"
        class="mt-3"
        :loading="loading"
        :pixels_when_update="150"/>
    </template>
  </MenuComponent>
</template>

<script>
import NavBar from 'components/common/blocks/NavBar.vue'
import MenuComponent from 'pages/templates/MenuComponent.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import SearchInput from 'components/common/inputs/SearchInput.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'
import GroupOfAccreditationCard from 'components/group of accreditations/GroupOfAccreditationCard.vue'

import { storageMixin } from 'mixins'

import GroupOfAccreditationsApi from '@/api/groupOfAccreditationsApi'
const api = new GroupOfAccreditationsApi()

export default {
  name: 'GroupOfAccreditationsList',
  mixins: [ storageMixin ],
  data() {
    return {
      filterOn: false,
      filterMode: [],
      activeMenuIndex: 0,
      loading: false,
      count: 0,
      per_page: 0,
      fields: [],
      filterByType: null,
      search: '',
      menuTypes: [
        {
          name: 'OrgSettings.MenuAll',
          icon: 'table',
          type: 'all'
        },
        {
          name: 'groupOfAccreditation.status.PUBLISHED',
          class: 'pl-7',
          icon: 'person-check',
          type: 'statusPublished',
          filter: el => {
            return el ? el.status === 'PUBLISHED' : false
          },
        },
        {
          name: 'groupOfAccreditation.status.DRAFT',
          class: 'pl-7',
          icon: 'edit',
          type: 'statusDraft',
          filter: el => {
            return el ? el.status === 'DRAFT' : false
          },
        },
        {
          name: 'groupOfAccreditation.status.ARCHIVE',
          class: 'pl-7',
          icon: 'time-ending',
          type: 'statusArchive',
          filter: el => {
            return el ? el.status === 'ARCHIVE' : false
          },
        },
        {
          name: 'Пропозиції',
          type: 'withBids',
          filter: el => {
            return el ? el.suppliersRequestStatistics?.some(i => i.count) : false
          },
        },
        {
          name: 'groupOfAccreditation.status.PENDING',
          class: 'pl-7',
          type: 'statusPending',
          filter: el => {
            return el ? el.suppliersRequestStatistics?.some(i => i.status === 'PENDING') : false
          },
        },
        {
          name: 'groupOfAccreditation.status.ACCREDITED',
          class: 'pl-7',
          type: 'statusAccredited',
          filter: el => {
            return el ? el.suppliersRequestStatistics?.some(i => i.status === 'ACCREDITED') : false
          },
        },
        {
          name: 'groupOfAccreditation.status.DECLINED',
          class: 'pl-7',
          type: 'statusDeclined',
          filter: el => {
            return el ? el.suppliersRequestStatistics?.some(i => i.status === 'DECLINED') : false
          },
        },
        {
          name: 'groupOfAccreditation.status.REWORKING',
          class: 'pl-7',
          type: 'statusReworking',
          filter: el => {
            return el ? el.suppliersRequestStatistics?.some(i => i.status === 'REWORKING') : false
          },
        },
      ],
    }
  },
  created() {
    this.$_getPropFromDBStorage('groupOfAccreditationPage_menuType', 0)
      .then((menuType) => {
        const index = this.menuTypes.findIndex(i => i.type === menuType)
        if (index !== -1) {
          this.activeMenuIndex = index
          this.choseType(this.menuTypes[index])
        }
      })
  },
  async mounted() {
    this.$root.$on('showOverlay', this.loadGroupOfAccreditations)

    const element = this.$el
    this.per_page = Math.floor((element?.clientHeight || 0) / 150) || 10
    await this.loadGroupOfAccreditations()
  },
  computed: {
    filtred_fields() {
      let result = this.fields

      // Фільтрація за типом
      if (this.filterByType) {
        result = result.filter(field => this.filterByType(field))
      }

      // Фільтрація за пошуковим запитом
      if (this.search) {
        const searchLower = this.search.toLowerCase()
        result = result.filter(field => {
          return field.title?.toLowerCase().includes(searchLower)
        })
      }

      return result
    },
    sliced_fields() {
      return this.filtred_fields.slice(0, this.count)
    },
    can_load() {
      return this.count !== this.filtred_fields.length
    }
  },
  methods: {
    choseType(type) {
      const index = this.menuTypes.findIndex(i => i.type === type.type)
      if (index !== -1) {
        this.activeMenuIndex = index
        this.$_savePropToDBStorage('groupOfAccreditationPage_menuType', type.type)
        this.filterByType = type.filter
        this.infinityLoad()
      }
    },
    infinityLoad() {
      const totalLength = this.filtred_fields.length
      this.count = Math.min(totalLength, this.count + this.per_page)
    },
    setNewStatus(itemId, status) {
      const item = this.fields.find(el => el?.id === itemId)
      if (item) {
        item.status = status
      }
    },

    async loadGroupOfAccreditations() {
      this.loading = true
      try {
        const result = await api.getAccreditationGroups()
        this.fields = result || []
        this.infinityLoad()
      } finally {
        this.loading = false
      }
    }
  },
  beforeDestroy() {
    this.$root.$off('showOverlay', this.loadGroupOfAccreditations)
  },
  components: {
    NavBar,
    EmptyBlock,
    SearchInput,
    MenuComponent,
    InfinityUpdater,
    GroupOfAccreditationCard,
  }
}
</script>
